// TYPES
import { UrlParamsToReplace } from '@/types/common.types';
import { ExternalUrlInputData } from '@/types/analytics';

// UTILITY
import store from '@/utility/store';
import { getExternalUrlParams } from '@/utility/analytics';

export const delay = (ms: number): Promise<boolean> => {
  return new Promise(resolve => {
    setTimeout(() => resolve(true), ms);
  });
};

export const trimCharacters = (value: string): string => {
  return value.replace(/[^\d]/g, '');
};

export const updateUrl = (url: string, params: UrlParamsToReplace = {}): string => {
  let updatedUrl = url;

  Object.keys(params).forEach(param => {
    updatedUrl = updatedUrl.replace(`{{${param}}}`, String(params[param]));
  });

  return updatedUrl;
};

export function formatExtLinks(text: string, params: ExternalUrlInputData) {
  const extParams = getExternalUrlParams(params);

  const newText = text.replace(/href=".*?"/gim, url => {
    return updateUrl(url, extParams);
  });

  return newText;
}

export const getPathName = (href: string): string => {
  const link = document.createElement('a');
  link.href = href || '';

  return link.pathname;
};

export const convertHTMLEntity = (text: string): string => {
  const span = document.createElement('span');

  return text.replace(/&[#A-Za-z0-9]+;/gi, entity => {
    span.innerHTML = entity;
    return span.innerText;
  });
};

export const formatPhoneMask = (phone: string): string => {
  return phone.toString().replace(/^(\d{3})(\d{3})(\d+).*/, '$1-$2-$3');
};

export const getSearchParams = (search: string): URLSearchParams => {
  const decodedUrl = decodeURIComponent(search);
  const params = new URLSearchParams(decodedUrl);

  return params;
};

export const storageAvailable = (): boolean => {
  try {
    store.set('test', 'test');
    store.remove('test');
    return true;
  } catch {
    return false;
  }
};

export const camelToSnakeCase = (str: string): string =>
  str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

// version from response - first param, local version second param
export const semverGreaterThan = (versionA = '0.0.0', versionB: string): boolean => {
  const versionsA = versionA.split(/\./g);

  const versionsB = versionB.split(/\./g);

  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift());

    const b = Number(versionsB.shift());

    // eslint-disable-next-line no-continue
    if (a === b) continue;

    return a > b || Number.isNaN(b);
  }
  return false;
};
